export const HOVER_SWIPE_DATA = [
  {
    title: '立体强化品牌形象',
    brief: '将企业空间入口部署至官网，全方位传递品牌形象，打造立体、动态品牌营销阵地',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/llainn1n_872874.png',
  },
  {
    title: '自定义企业空间分区',
    brief: '支持企业自定义设计活动空间和功能区，让企业活动更加沉浸多元、活跃有趣',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/llainn1o_872875.png',
  },
  {
    title: '沉浸式 AI 交互体验',
    brief: '支持音视频畅聊、私聊交友，提供虚拟 AI 前台咨询服务，提升客户满意度与留存率',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/llainn1p_872875.png',
  },
];

export const TAB_CARD_DATA = [
  {
    title: '场景定制',
    brief:
      '依托于网易美术建模能力，将产品 1:1 还原至线上，多形式展示产品、案例，定制更创意性的企业空间，满足不同品牌对品牌理念更丰富的传达，将线上场景与品牌形象相结合。',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/llascub2_165228.png',
  },
  {
    title: '空间能力',
    brief:
      '一站式满足企业对前台、会议室、荣誉墙、报告厅、洽谈室、企业历史等空间的自由分配，全方位满足企业形象展示、客户接待、商务洽谈、远程办公、新品发布、培训学习等多样需求。',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/llascub3_165228.png',
  },
  {
    title: '数字员工',
    brief:
      '通过国内自研模型开发，在网易瑶台自有平台部署，安全性更高，支持用户上传语料包进行定制化训练；通过数字员工为游客实现一对一解答和游览引导，帮助游客自助式了解企业。',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/llascub0_165227.png',
  },
  {
    title: '游客分析',
    brief:
      '通过空间游客热力图进行人流量数据分析，反哺线下展区及时进行线下空间位置调整，通过后台统一管理空间内游客参与形式、人数等，下载相关数据，方便及时复盘总结。',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/llascub1_165227.png',
  },
];

export const VIDEO_SWIPE_DATA = [
  {
    title: '一站式企业空间',
    brief: '跨平台支持 | 全场景覆盖 | 创新技术集成',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/lmh546c7_175319.png',
    darkImgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/lmj68oau_997187.png',
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lmojbr9h_306884.mp4',
    serialNum: 0,
    swiperDelay: 15000,
  },
  {
    title: '定制化品牌形象',
    brief: '商务合作洽谈 | 线上活动营销 | 3D数字办公',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/lmh54ddn_184443.png',
    darkImgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/lmj68oas_997187.png',
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lmhg9rf4_911696.mp4',
    serialNum: 1,
    swiperDelay: 17000,
  },
  {
    title: 'AI驱动交互体验',
    brief: '智能化定制问答 | 个性化专属服务 | 拟真化语音',
    extraBrief: '交互',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/lmh54ddo_184443.png',
    darkImgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/lmj68oat_997187.png',
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lmojbr9g_306884.mp4',
    serialNum: 2,
    swiperDelay: 20000,
  },
];

export type VideoCardDataType = {
  title: string;
  brief: string;
  extraBrief?: string;
  imgSrc: string;
  darkImgSrc: string;
  video: string;
  serialNum: number;
  swiperDelay: number;
};
